export const data = [
   
    {
        nama: "Find A Job",
        use :"React.js,Bootstrap, Javascript, Redux, Axios,  React Hook",
        duration: "3 days",
        desc: "a content about kpop boyband stray kids with up to date technologies and frameworks",
        foto: "https://jubelio.netlify.app/static/media/job.7f725d18425e81f687fa.jpg",
        katagori : "react",
        link : "https://jobislah.netlify.app/"
    },
    {
        nama: "Olla Shop",
        use :"React.js,firebase,axios,redux,Bootstrap, Javascript, React Hook",
        duration: "3 days",
        desc: "a content about kpop boyband stray kids with up to date technologies and frameworks",
        foto: "https://jubelio.netlify.app/static/media/shop.236c411c18623ad4db0a.jpg",
        katagori : "react",
        link : "https://ollashop.netlify.app/"
    },
    {
        nama: "Stray kids",
        use :"React.js,Bootstrap, Javascript,  React Hook, React-context",
        duration: "3 days",
        desc: "a content about kpop boyband stray kids with up to date technologies and frameworks",
        foto: "https://islahola.netlify.app/static/media/skz.6eb84cb71ef356062ea8.PNG",
        katagori : "react",
        link :"straykidsolla.netlify.app"
    },
    {
        nama: "Kanban Board ",
        use :"React.js,Bootstrap, Javascript,  React Hook",
        duration: "7 days",
        desc: " Created a content about Notes and everything with up to date technologies and frameworks.",
        foto: "https://islahola.netlify.app/static/media/kanban.45b9dbf908470ed792cc.PNG",
        katagori : "react",
        link : "https://mykanbanboard.netlify.app/"
    },
    {
        nama: "Kasirku ",
        use :"React.js,Bootstrap, Javascript,  React Hook",
        duration: "4 days",
        desc: " Created a content about Notes and everything with up to date technologies and frameworks.",
        foto: "https://islahola.netlify.app/static/media/kasir.83bc41ff356f7556f277.png",
        katagori : "react",
        link : "https://kasirolla.netlify.app/"
    },
    {
        nama: "Pet Hero ",
        use :"Laravel,SASS,Bootstrap, Javascript and Jquery",
        duration: "5 days",
        desc: "Created a about hero and everything with up to date technologies and frameworks.",
        foto: "https://islahola.netlify.app/static/media/petheroLaravel.dbff2704398281be2d2f.PNG",
        katagori : "laravel",
        link :"http://pethero.rf.gd/"
    },
    {
        nama: "Severless ",
        use :"Laravel,SASS,BootstrapPHP, Javascript, AWS and Jquery",
        duration: "Stil Develop",
        desc: "Created a about hero and everything with up to date technologies and frameworks.",
        foto: "https://islahola.netlify.app/static/media/severless.38b8971eadde36246a99.PNG",
        katagori : "laravel",
        link :"https://eloquent-dubinsky-906e84.netlify.app/"
    },
    {
        nama: "Desa Cijujung ",
        use :"Laravel,SASS,Bootstrap, Javascript and Jquery",
        duration: "2 Weks",
        desc: "Created a website desa cijujung jawabarat with up to date technologies and frameworks.",
        foto: "https://islahola.netlify.app/static/media/desa.020f531457df128c28f2.PNG",
        katagori : "laravel",
        link : "https://github.com/islahola/cijujung"
    },
    {
        nama: "BPJS ",
        use :"Figma",
        duration: "1 Weks",
        desc: "Created Created website design bpjs with up to date technologies.",
        foto: "https://islahola.netlify.app/static/media/bpjs.e5df3bb98b3e215afba0.png",
        katagori : "design",
        link : ""
    },
    {
        nama: "Pet Hero Mobile ",
        use :"Figma",
        duration: "2 days",
        desc: "Created website design heropet with up to date technologies and collaboration with 3 people",
        foto: "https://islahola.netlify.app/static/media/pethero.d2dc2363f29aca5bba81.PNG",
        katagori : "design",
        link : "https://www.figma.com/file/KneMfimbppl3JI7Hu4vg6d/wireframe?node-id=0%3A1&t=zwRUQirOhnFbTfa1-1"
    },
    {
        nama: "Staykids ",
        use :"Figma",
        duration: "2 Days",
        desc: "Created website design stray kids with up to date technologies",
        foto: "https://islahola.netlify.app/static/media/figma-skz.fe765ae77de8835a654b.PNG",
        katagori : "design",
        link : "https://www.figma.com/file/YvmzaILcpKYUbpmr3ZK7JZ/Untitled?node-id=0%3A1&t=Pbwg46kosKmcFSwJ-1"
    }
]